import { render, staticRenderFns } from "./PayOnly.vue?vue&type=template&id=9fdb007a&scoped=true&"
import script from "./PayOnly.vue?vue&type=script&lang=js&"
export * from "./PayOnly.vue?vue&type=script&lang=js&"
import style0 from "./PayOnly.vue?vue&type=style&index=0&id=9fdb007a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdb007a",
  null
  
)

export default component.exports